import { assign } from 'fsm';
import I18n from 'I18n';
import Raven from 'raven-js';
import { fetchEnrichmentSettings, fetchFeatureStates, updateEnrichmentSetting } from './client';
export const machine = {
  initial: 'loading',
  states: {
    loading: {
      invoke: {
        src: 'fetchEnrichmentSettings',
        onDone: {
          target: 'loadingFeatureStates',
          actions: ['setEnrichmentSettings']
        },
        onError: {
          target: 'idle',
          actions: ['addLoadingError', 'logError']
        }
      },
      tags: ['loading']
    },
    loadingFeatureStates: {
      invoke: {
        src: 'fetchFeatureStates',
        onDone: {
          target: 'idle',
          actions: ['setFeatureStates']
        },
        onError: {
          target: 'idle',
          actions: ['setEmptyFeatureStates', 'logError']
        }
      },
      tags: ['loading']
    },
    idle: {
      on: {
        TOGGLE_SETTING: [{
          target: 'updating'
        }]
      }
    },
    updating: {
      invoke: {
        src: 'updateEnrichmentSetting',
        onDone: {
          target: 'idle',
          actions: ['setUpdatedEnrichmentSetting', 'addUpdatingSuccess']
        },
        onError: {
          target: 'idle',
          actions: ['addUpdatingError', 'logError']
        }
      }
    }
  },
  actions: {
    addLoadingError: context => {
      var _context$addAlertDang;
      (_context$addAlertDang = context.addAlertDanger) === null || _context$addAlertDang === void 0 || _context$addAlertDang.call(context, {
        message: I18n.text('enrichmentProperties.settings.fetchingError.message'),
        titleText: I18n.text('enrichmentProperties.settings.fetchingError.title')
      });
    },
    addUpdatingError: context => {
      var _context$addAlertDang2;
      (_context$addAlertDang2 = context.addAlertDanger) === null || _context$addAlertDang2 === void 0 || _context$addAlertDang2.call(context, {
        message: I18n.text('enrichmentProperties.settings.changeSettingError.message'),
        titleText: I18n.text('enrichmentProperties.settings.changeSettingError.title')
      });
    },
    addUpdatingSuccess: context => {
      var _context$addAlertSucc;
      (_context$addAlertSucc = context.addAlertSuccess) === null || _context$addAlertSucc === void 0 || _context$addAlertSucc.call(context, {
        message: I18n.text('enrichmentProperties.settings.changeSettingSuccess.message'),
        titleText: I18n.text('enrichmentProperties.settings.changeSettingSuccess.title')
      });
    },
    logError: (_context, event) => {
      const {
        responseJSON
      } = event.data;
      Raven.captureException(responseJSON);
    },
    setEnrichmentSettings: assign((_context, event) => {
      return {
        settings: event.data
      };
    }),
    setEmptyFeatureStates: assign(() => {
      return {
        featureStates: {
          enrichmentContact: false,
          enrichmentCompany: false,
          smartProperties: false
        }
      };
    }),
    setFeatureStates: assign((_context, event) => {
      return {
        featureStates: event.data
      };
    }),
    setUpdatedEnrichmentSetting: assign((context, event) => {
      const {
        key,
        value
      } = event.data;
      return {
        settings: Object.assign({}, context.settings, {
          [key]: value
        })
      };
    })
  },
  services: {
    fetchEnrichmentSettings,
    fetchFeatureStates,
    updateEnrichmentSetting: (context, event) => {
      const {
        key
      } = event.data;
      return updateEnrichmentSetting({
        key,
        value: !context.settings[key]
      });
    }
  }
};